import { GENERAL_TABLE_OTHERS_INFO_SUCCESS } from "../../../../Constant/ApaManagement/ApaPreparationByUser/GeneralTable/GeneralTableOtherInfoConstant";
 

export const getGeneralTableOthersInfoReducer = (state = { generalTableOthersInfo: [] }, action) => {

    switch (action.type) {
        case GENERAL_TABLE_OTHERS_INFO_SUCCESS:
            return {
                ...state,
                loading: false,
                generalTableOthersInfo: action.payload


            }

        default:
            return state
    }


};